import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import { useAddNewassetReqMutation } from '../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import useAuth from '../../../features/hooks/useAuth';
import { useGetAssetsFinalQuery, useUpdateAssetintransitMutation } from '../../../features/addassets/addassetfinalApiSlice';
import EnhancedTable from './OffAssetHandoverReqTable'
import { useGetStoreOfficesQuery } from '../../../features/storeoffices/storeofficesApiSlice'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useNavigate } from "react-router-dom";
import {
    HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper,
    RequestClosureWarapperAccepted, RequestClosureWarapperRejected, AddRemarkButton, BackButtonSpan, ReqWrapper, StoreNameCont, ExtReqWrapper, PopupButton
} from '../../../Styles/CommonStyles'

const Container = styled.div``
const Wrapper = styled.div``
const RequestWrapper = styled.div``
const IntRequestWrapper = styled(IntReqWrapper)``
const SelectContainer = styled.div`
display: flex;
align-items: center;
margin-bottom: 25px;
`
const Option = styled.option`
font-weight: 100;
`
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const StoreSelect = styled.select`
width: 30%;
height: 25px;
`
const UserSelect = styled.select`
width: 30%;
height: 35px;
`
const TextInputWrap = styled.div`
height: 30vh;
`
const SubmitButton = styled(CommonButton)`
`

const OffAssetHandoverReq = () => {

    const [content, setContent] = useState('');
    const editor = useRef(null);
    const [storeSelectedValue, setStoreSelectedValue] = useState('')

    //created hook to pass data from ofcassettable to parent
    const [intSelected, setIntSelected] = useState([])

    //logged in user data
    const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    // all users call 
    const {
        data: usersdata,
        isLoading: usersLoading,

    } = useGetUsersQuery('userslist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let users = usersdata ? Object.values(usersdata?.entities) : []

    //usercall/single user call
    const { getSingleuser } = useGetUsersQuery('userslist', {
        selectFromResult: ({ data }) => ({
            getSingleuser: data?.entities
        }),
    })

    //store offices 
    const {
        data: allstoreoffices
    } = useGetStoreOfficesQuery('allstorelists', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempstoredata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []
    let allstoresdata = tempstoredata
    let storesNameArray = allstoresdata.map(elm => elm.storeoffice)

    // find selected store office documnet to find the assetmanager ID
    let selectedStoreDoc = allstoresdata.filter(elm => elm.storeoffice === storeSelectedValue)

    // find assetmanger level -1 Id (for unithead role)
    let assetManagerL1Id = selectedStoreDoc[0]?.roleUsers?.level1approver

    //add mutation call
    const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation()

    //assets in transit status update call 
    const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

    //in transit body 
    // assets which are not in transit
    let notinTransitAssets = intSelected?.filter(elm => !(elm.in_transit))
    let assetTranBody = { selectedAssetarray: notinTransitAssets, transtatus: true }

    // create send to the assetmanager level-1 of the selected store
    let sendStoreManL1Obj = { id: assetManagerL1Id, name: getSingleuser && getSingleuser[assetManagerL1Id]?.name, office: user_current_office, designation: getSingleuser && getSingleuser[assetManagerL1Id]?.designation[user_current_office], designationSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.designationSuffix[user_current_office], numSuffix: getSingleuser && getSingleuser[assetManagerL1Id]?.numSuffix[user_current_office] }

    //************************************************************************ */
    //create a unique Id
    const uniqueReqID = () => {
        const dateString = Date.now().toString(36);
        const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
        const uid = `${emailofuser}-${dateString}`
        return uid;
    };

    let uniqueReqId = uniqueReqID()
    //****************************************************************************** */

    let userReqData = {
        uniqueReqId: uniqueReqId,
        req_type: 'ofc_asset_handover',
        req_cat: 'byBotoStore',
        req_creator: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        req_store: storeSelectedValue,
        sent_to_tag: 'level_1_approver',
        curr_status: 'pending',
        created_at: new Date(),
        curr_sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        curr_sent_to: sendStoreManL1Obj,
        req_data: [{
            // save all assets 
            assets_details: intSelected,
            non_transit_assets: notinTransitAssets,
            Text: content,
            sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
            sent_to: sendStoreManL1Obj,
            status: 'pending',
            time_stamp: new Date()
        }]
    }

    const navigate = useNavigate();

    const handleReqSubmit = async () => {
        if (assetManagerL1Id) {
            try {
                await addNewRequest(userReqData).unwrap()
                await updateAssetinTran(assetTranBody)
                navigate('management/assets/bo')
                return alert('your request is forwarded to the store manger')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        } else {
            return alert('Please register the user')
        }
    }



    return (
        <Container>
            <Wrapper>
                <RequestWrapper>
                    <HeadingWrap>
                        <Span>Select assets</Span>
                    </HeadingWrap>
                    <SelectContainer>
                        <Autocomplete
                            id="combo-box-demo"
                            options={storesNameArray.map(elm => elm)}
                            sx={{ width: 600 }}
                            value={storeSelectedValue}
                            onChange={(event, newValue) => {
                                setStoreSelectedValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} label="Please Select Store" />}
                        />
                        {/* <Styledlabel>Select Store:</Styledlabel>
                        <StoreSelect value={storeSelectedValue} onChange={e => setStoreSelectedValue(e.target.value)}>
                            <Option value='' selected disabled>Select value</Option>
                            {storesNameArray.map((elm, index) => (<Option key={index} value={elm}>{elm}</Option>))}
                        </StoreSelect> */}
                    </SelectContainer>
                    <IntRequestWrapper><EnhancedTable setIntSelected={setIntSelected} storeSelectedValue={storeSelectedValue} /></IntRequestWrapper>
                    <TextInputWrap>
                        <HeadingWrap>
                            <Span>Details/Justifications</Span>
                        </HeadingWrap>
                        <JoditEditor
                            ref={editor}
                            value={content}
                            onBlur={newContent => setContent(newContent)}
                            onChange={newContent => { }}
                        />
                    </TextInputWrap>
                </RequestWrapper>
                <SubmitButton onClick={handleReqSubmit}>Sent to the store Manager</SubmitButton>
            </Wrapper>
        </Container>
    )
}

export default OffAssetHandoverReq